import { Account, SCRIPT } from "callable-data-objects";
import { CallableInput, CountrySelect } from "Components/Shared";
import ASRSelect from "Components/Shared/ASRSelect";
import FormSubmit from "Components/Shared/FormSubmit";
import RecordingRetention from "Components/Shared/RecordingRetention";
import TeamsDomainType from "Components/Shared/TeamsDomainType";
import TimezoneSelect from "Components/Shared/TimezoneSelect";
import TTSSelect from "Components/Shared/TTSSelect";
import VoiceClusterName from "Components/Shared/VoiceClusterName";
import CallableVersion from "Components/Shared/CallableVersion";
import { Field, Formik } from "formik";
import { useSetting } from "Hooks/Endpoints";
import React from "react";
import { Dimmer, Form, Loader, Segment } from "semantic-ui-react";
import DeviceSelect from "Components/Shared/DeviceSelect";

type AccountSettingType = {
  account: Account;
  name: string;
  type: string;
  label: string;
  placeholder?: string;
  min?: number;
  max?: number;
};
function AccountSetting({
  name,
  type,
  label,
  account,
  min,
  max,
  placeholder,
}: AccountSettingType) {
  const { update, loading, remove } = useSetting();
  const value = account.settings.find((s) => s.key === name)?.value;
  return (
    <Segment>
      <Dimmer.Dimmable dimmed={loading}>
        <Formik
          initialValues={{
            key: value,
          }}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            if(values.key !== "") {
              update(name, {
                key: name,
                id: name,
                value: values.key,
                type,
              });
            } else {
              remove(name);
            }
          }}
        >
          {({ handleSubmit, setFieldValue, errors, validateField }) => (
            <Form onSubmit={handleSubmit}>
              {type === "countryCode" && (
                <CountrySelect name='key' label={label} />
              )}
              {type === "timeZone" && (
                <TimezoneSelect name='key' label={label} />
              )}
              {type === "ttsLanguage" && <TTSSelect name='key' label={label} />}
              {type === "asrLanguage" && <ASRSelect name='key' label={label} />}
              {type === "recording.retention" && (
                <RecordingRetention name='key' label={label} />
              )}
              {type === "teamsDomainType" && (
                <TeamsDomainType name='key' label={label} />
              )}
              {type === "clusterName" && (
                <VoiceClusterName name='key' label={label} />
              )}
              {type === "callableVersion" && (
                <CallableVersion name='key' label={label} />
              )}
              {type === "ingressScript" && (
                <DeviceSelect
                  name='key'
                  label={label}
                  type={SCRIPT}
                  devices={account.devices}
                />
              )}

              {type === "string" && (
                <Field name='key' label={label} component={CallableInput} />
              )}
              {type === "number" && (
                <Field
                  name='key'
                  label={label}
                  type='number'
                  min={min}
                  max={max}
                  placeholder={placeholder}
                  component={CallableInput}
                />
              )}
              <FormSubmit name='Update' errors={errors} />
            </Form>
          )}
        </Formik>
        <Dimmer inverted active={loading}>
          <Loader />
        </Dimmer>
      </Dimmer.Dimmable>
    </Segment>
  );
}

export default AccountSetting;
